<template>
    <div class="py-4 container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header pb-0">
                        <div class="d-flex align-items-center">
                            <p class="mb-0">Crear crédito</p>
                        </div>
                    </div>
                    <div class="card-body">
                        <form @submit.prevent="submit">
                            <div class="row">
                                <div class="col-md-12">
                                    <label for="example-text-input" class="form-control-label"
                                    >DATOS DEL CLIENTE</label
                                    >
                                </div>
                                <div class="col-md-6">
                                    <div><label for="example-text-input" class="form-control-label"
                                    >Foto del cliente</label
                                    ></div>
                                    <div>
                                        <img :src="client.photo_url ? client.photo_url : fileUpload" style="max-width:50%;" class="mx-auto"  />
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    
                                </div>
                                <div class="col-md-6">
                                    <div>
                                    <label for="example-text-input" class="form-control-label"
                                    >Parte Frontal de documento de identidad</label
                                    ></div>
                                    <div>
                                        <img :src="client.document_front_url ? client.document_front_url : fileUpload" style="max-width:50%;" class="mx-auto"/>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div><label for="example-text-input" class="form-control-label"
                                    >Parte Trasera de documento de identidad</label
                                    ></div>
                                    <div>
                                        <img :src="client.document_back_url ? client.document_back_url : fileUpload" style="max-width:50%;" class="mx-auto"/>
                                    </div>
                                </div>
                                
                                <div class="col-md-6">
                                    <label for="example-text-input" class="form-control-label"
                                    >Documento de identidad</label
                                    >
                                    <argon-input id="code"
                                    type="text" read="true" v-model="client.document" 
                                    />
                                    <small v-if="submitted && v$.client.document.$error" class="text-danger">Documento de identidad es requerido</small>
                                </div>
                                <div class="col-md-6">
                                    <label for="example-text-input" class="form-control-label"
                                    >Tipo de cliente</label
                                    >
                                    <argon-select type="text" read="true" class="form-control" v-model="client.client_type" :choices="type"/>
                                </div>
                                <div class="col-md-12">
                                    <label for="example-text-input" class="form-control-label"
                                    >Nombres y Apellidos</label
                                    >
                                    <argon-input id="code"
                                    type="text" read="true" v-model="client.name" 
                                    />
                                    <small v-if="submitted && v$.client.name.$error" class="text-danger">Nombre y apellido es requerido</small>
                                </div>
                                <div class="col-md-6">
                                    <label for="example-text-input" class="form-control-label"
                                    >Sexo</label
                                    >
                                    <argon-select type="text" read="true" class="form-control"  v-model="client.sex" :choices="sex"/>
                                </div>
                                <div class="col-md-6">
                                    <label for="example-text-input" class="form-control-label"
                                    >Fecha de nacimiento</label
                                    >
                                    <VueDatePicker read="true" v-model="client.birth_date" 
                                    :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                                    :min-date="minCfgDate" :max-date="maxCfgDate"
                                    :enable-time-picker="false" auto-apply readonly="readonly"/>
                                </div>
                                
                                <div class="col-md-12">
                                    <label for="example-text-input" class="form-control-label"
                                    >Dirección</label
                                    >
                                    <argon-textarea read="true" v-model="client.address"/>
                                </div>
                                <div class="col-md-6">
                                    <label for="example-text-input" class="form-control-label"
                                    >Teléfono</label
                                    >
                                    <argon-input id="code" read="true"
                                    type="text" v-model="client.phone" 
                                    />
                                </div>
                                <div class="col-md-6">
                                    <label for="example-text-input" class="form-control-label"
                                    >Correo</label
                                    >
                                    <argon-input id="code" read="true"
                                    type="text" v-model="client.email" 
                                    />
                                </div>
                                            
                                <div class="col-md-12">
                                    <label for="example-text-input" class="form-control-label"
                                    >DATOS DEL CRÉDITO</label
                                    >
                                </div>
                                <div class="col-md-6">
                                    <label for="example-text-input" class="form-control-label"
                                    >Producto</label
                                    >
                                    <argon-select type="text" class="form-control" v-model="loan.product_id" :choices="products" read="true" />
                                </div>
                                
                                <div class="col-md-6">
                                    <label for="example-text-input" class="form-control-label"
                                    >Tasa de Interés</label
                                    >
                                    <argon-input id="code"
                                    read="true" 
                                    type="text" v-model="loan.rate" 
                                    />
                                </div>
                                <div class="col-md-6">
                                    <label for="example-text-input" class="form-control-label"
                                    >Monto Total</label
                                    >
                                    <argon-input id="code"
                                    read="true" 
                                    type="text" v-model="loan.total_amount" 
                                    />
                                </div>
                                <div class="col-md-6">
                                    <label for="example-text-input" class="form-control-label"
                                    >Tasa de Interés Moratorio</label
                                    >
                                    <argon-input id="code"
                                    read="true" 
                                    type="text" v-model="loan.late_interest" 
                                    />
                                </div>
                                <div class="col-md-6">
                                    <label for="example-text-input" class="form-control-label"
                                    >Plazo</label
                                    >
                                    <argon-input id="code"
                                    type="text" v-model="loan.term"  read="true" 
                                    />
                                </div>
                                <div class="col-md-6">
                                    <label for="example-text-input" class="form-control-label">Condición de crédito</label>
                                    <argon-select type="text" class="form-control" v-model="loan.condition_level" :choices="conditions" read="true" />
                                        
                                </div>
                                
                                <div class="col-md-6">
                                    <label for="example-text-input" class="form-control-label"
                                    >Fecha de Inicio</label
                                    >
                                    <VueDatePicker v-model="loan.init_date" 
                                    locale="es"
                                    format="dd/MM/yyyy"
                                    :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                                    :min-date="minCfgDate" :max-date="maxCfgDate"
                                    :enable-time-picker="false" auto-apply readonly="readonly"/>
                                </div>
                                <div class="col-md-6">
                                    <label for="example-text-input" class="form-control-label"
                                    >Fecha Final</label
                                    >
                                    <VueDatePicker read="true" v-model="loan.end_date" 
                                    locale="es"
                                    format="dd/MM/yyyy"
                                    :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                                    :min-date="minCfgDate" :max-date="maxCfgDate"
                                    :enable-time-picker="false" auto-apply readonly="readonly"/>
                                </div>
                                <div class="col-md-12">
                                    <label for="example-text-input" class="form-control-label"
                                    >Comentarios</label
                                    >
                                    <argon-textarea v-model="loan.comments" read="true" />
                                </div>
                                <div class="col-md-12">
                                    <div class="table-responsive p-0">
                                        <label for="example-text-input" class="form-control-label"
                                        >PLAN DE PAGOS</label
                                        >
                                        <table class="table align-items-center mb-0">
                                        <thead>
                                            <tr>
                                            <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">No.</th>
                                            <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Fecha</th>
                                            <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Capital</th>
                                            <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Interés</th>
                                            <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Interés moratorio</th>
                                            <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Cargos</th>
                                            <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Total</th>
                                            <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Total pagado</th>
                                            <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Estado</th>
                                            <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Fecha de pago</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(item, index) in paymentPlan" :key="index">
                                            <td>{{ item.number }}</td>
                                            <td>{{ item.date }}</td>
                                            <td class="text-end">{{ item.capital}}</td>
                                            <td class="text-end">{{ item.interest }}</td>
                                            <td class="text-end">{{ (item.late_interest||0)}}</td>
                                            <td class="text-end">{{ (item.charges ||0.00)}}</td>
                                            <td class="text-end">{{ item.total}}</td>
                                            <td class="text-end">{{ (item.payed_amount||0.00)}}</td>
                                            <td>
                                                <span v-if="item.payed === 0" class="text-warning">Pendiente</span>
                                                <span v-if="item.payed === 1" class="text-success">Pagado</span>
                                            </td>
                                            <td>{{ item.payed_date ? item.payed_date : 'N/A' }}</td>
                                            </tr>
                                        </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            <argon-button
                                type="submit" 
                                class="mt-4"
                                color="success"
                                fullWidth
                                size="lg"
                                
                                >Imprimir</argon-button>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import ArgonInput from "@/components/ArgonInput.vue";
//import ArgonInputNumber from "@/components/ArgonInputNumber.vue";
import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css'
import ArgonSelect from "@/components/ArgonSelect.vue";
import ArgonTextarea from "@/components/ArgonTextarea.vue";
import ArgonButton from "@/components/ArgonButton.vue";
import {useVuelidate} from '@vuelidate/core';
import {required} from  '@vuelidate/validators';
import axios from "axios";
import fileUpload from'@/assets/img/uploadfile.jpg';
export default {
    name: "company",
    setup:() => ({ v$: useVuelidate() }), 
    data() {
        const now = new Date()
        const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
        // 15th two months prior
        const minDate = new Date(today)
        minDate.setFullYear(1900)
        minDate.setMonth(minDate.getMonth() - 2)
        minDate.setDate(15)
        // 15th in two months
        const maxDate = new Date(today)
        maxDate.setMonth(maxDate.getMonth())
        maxDate.setDate(maxDate.getDate()+1)
        maxDate.setFullYear(maxDate.getFullYear()+25)
        return {
            fileUpload,
            showMenu: false,
            submitted:false,
            maxCfgDate:maxDate,
            minCfgDate:minDate,
            testClasifications:[],
            testTypes:[],
            client:{
                document:null,
                name:null,
                birth_date:now,
                sex:1,
                address:null,
                email:null,
                phone:null,
                client_type:1,
                education:0,
                profession:0,
                company_id:1,
                qualification:"A",
                state:1,
                work_name:null,
                work_address:null,
                work_phone:null,
                photo_url:null,
                document_front_url:null,
                document_back_url:null,
                //created_date:now
            },
            sex:[
                {value:1,text:'Masculino'},
                {value:2,text:'Femenino'}
            ],
            type:[
                {value:1,text:'Persona Natural Nacional'},
                {value:2,text:'Persona Natural Extranjera'},
                {value:3,text:'Persona Jurídica Nacional'},
                {value:4,text:'Persona Jurídica Extranjera'},
            ],
            conditions:[
                { value: 1, text: 'Diario' },
                //{ value: 2, text: 'Semanal' },
                //{ value: 3, text: 'Quincenal' },
                { value: 4, text: 'Mensual' },
            ],
            products:[
                {value:1,text:"Consumo personal", default_rate:40, late_rate:10, min:400, max:2700},
                {value:2,text:"Crédito pyme", default_rate:40, late_rate:10, min:400, max:2700},
                {value:3,text:"Consolidación de deudas", default_rate:40, late_rate:10, min:400, max:2700},
                {value:4,text:"Motocicleta", default_rate:40, late_rate:10, min:1000, max:2700},
            ],
            education:[
                {value:0,text:'Ejemplo'},
            ],
            profession:[
                {value:0,text:'Ejemplo'},
            ],
            loan:{
                client_id:this.$route.params.id,
                amount:0,
                rate:20,
                total_amount:0,
                type:0,
                term:0,
                condition_level:4,
                init_date:today,
                end_date:today,
                state:0,
                company:1,
                comments:null,
                balance:0,
                late_interest:0,
                product_id:0
            },
            paymentPlan:null,
            min:0,
            max:0
        };
    },
    components: {
        ArgonInput, 
        //ArgonInputNumber,
        VueDatePicker,
        ArgonButton, 
        ArgonTextarea, 
        ArgonSelect,
    },
    validations(){
        return{
            client:{
                document:{required},
                name:{required},
                birth_date:{required},
            },
        }
    },
    watch: {

    },
    methods:{
        fetchLoanData(config){
            let self=this;
            fetch(this.$store.state.apiURL+'view/loans/'+this.$route.params.id, config)
            .then(response=>response.json())
            .then(result=> {
                console.log(result); 
                this.loan=result.loans;
                this.fetchPaymentPlan(config);
            })
            .catch(error => {
                console.log(error)
                self.$swal({
                    title: 'Sesión',
                    text: 'El tiempo de sesión a vencido, ingresa nuevamente.',
                    type: 'warning',
                    icon:'warning',
                    showCancelButton: false,
                    confirmButtonColor:'#0b9257',
                    showCloseButton: true,
                    showLoaderOnConfirm: false  
                }).then(function(){
                    localStorage.removeItem('user');
                    localStorage.removeItem('accessToken');
                    self.$router.push('/signin');
                });    
            });

        },
        fetchPaymentPlan(config){
            let self=this;
            fetch(this.$store.state.apiURL+'list/payment_plan?loand_id='+this.$route.params.id+'&sort=number&order=ASC&recperpage=all', config)
            .then(response=>response.json())
            .then(result=> {
                console.log(result); 
                this.paymentPlan=result.payment_plan.sort((a,b)=> a.number-b.number);
                this.fetchClientData(config);
            })
            .catch(error => {
                console.log(error)
                self.$swal({
                    title: 'Sesión',
                    text: 'El tiempo de sesión a vencido, ingresa nuevamente.',
                    type: 'warning',
                    icon:'warning',
                    showCancelButton: false,
                    confirmButtonColor:'#0b9257',
                    showCloseButton: true,
                    showLoaderOnConfirm: false  
                }).then(function(){
                    localStorage.removeItem('user');
                    localStorage.removeItem('accessToken');
                    self.$router.push('/signin');
                });    
            });
        },
        fetchClientData(config){
            let self=this;
            fetch(this.$store.state.apiURL+'view/clients/'+this.loan.client_id, config)
            .then(response=>response.json())
            .then(result=> {
                console.log(result); 
                this.client=result.clients;
            })
            .catch(error => {
                console.log(error)
                self.$swal({
                    title: 'Sesión',
                    text: 'El tiempo de sesión a vencido, ingresa nuevamente.',
                    type: 'warning',
                    icon:'warning',
                    showCancelButton: false,
                    confirmButtonColor:'#0b9257',
                    showCloseButton: true,
                    showLoaderOnConfirm: false  
                }).then(function(){
                    localStorage.removeItem('user');
                    localStorage.removeItem('accessToken');
                    self.$router.push('/signin');
                });    
            });
        },
        uploadPhoto(e){
            console.log(e);
            if(e=='documentFront'){
                this.$refs.clientFrontFile.click();
            }else if(e=='documentBack'){
                this.$refs.clientBackFile.click();
            }else{
                this.$refs.clientPhotoFile.click();
            }
        },
        onFileChange(type, event){
            let self=this;
            const file = event.target.files[0];
            console.log(file)
            let formData=new FormData();
            let fileU;
            let filename='jpg';
            if(file){
                fileU=URL.createObjectURL(file);
                console.log(fileU);
                formData.append('file', file);
                formData.append('fileName', filename);
                axios.post(this.$store.state.fileURL, formData,
                    {
                    headers: {
                        "Authorization": "Basic cHJpdmF0ZV9XVXVROG1DQncxV210WHc1empIa3NGQkNZQ1E9Og==",
                        'Content-Type': 'multipart/form-data; boundary=---011000010111000001101001'
                    }
                }).then(function(result){
                    console.log(result);
                    if(type=='front'){
                        self.client.document_front_url=result.data.url;
                    }else if(type=='back'){
                        self.client.document_back_url=result.data.url;
                    }else{
                        self.client.photo_url=result.data.url;
                    }
                })
            }
        },
        
    },
    mounted() {
        const token = localStorage.getItem("accessToken");
        const config = {headers: {"X-Authorization": `Bearer ${token}`}};
        this.fetchLoanData(config);
        //this.fetchClientData(config);
        //this.fetchTestTypes(config);
    },
    beforeMount() {

    },
    beforeUnmount() {

    }
};
</script>